import api from '../api'

export default {
    namespaced: true,
    state: {
        userLeaveTableList: {
            beanList: [],
            total: 0,
        }
    },
    mutations: {
        setStateUserLeaveTableList(state, info) {
            state.userLeaveTableList = info
        },
    },
    actions: {
        getUserLeaveTableList({commit}, params) {
            return api.post('/usermemger/userInfoLeaveTableList', '离桌玩家列表', params).then(res => {
                commit('setStateUserLeaveTableList', res.data)
            })
        },
    }
}